import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the harmless "ResizeObserver loop completed with undelivered notifications"
// error. It's fired by Radix/Recharts when layout changes happen inside an observer
// callback. CRA's dev error overlay promotes it to a red runtime error even though
// it's a warning-level event and is explicitly ignored by browsers.
const RESIZE_OBSERVER_RE = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (e) => {
  if (e?.message && RESIZE_OBSERVER_RE.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || String(e?.reason || "");
  if (RESIZE_OBSERVER_RE.test(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
